import styled from 'styled-components';
import { Link } from 'core/routing';
import { hexa } from 'legacyComponents/styled/styleUtils';

export const FakeLink = styled.span`
  font-size: 0.9em;
  color: ${props =>
    props.danger ? props.theme.color.wfOrange : props.theme.color.primary};
  font-weight: ${props => (props.mention ? '400' : '600')};
  background-color: ${props =>
    props.mention ? `${hexa(props.theme.color.primary, 0.1)}` : 'transparent'};
  border: ${props =>
    props.mention
      ? `1px solid ${hexa(props.theme.color.primary, 0.2)}`
      : 'transparent'};
  border-radius: ${props => (props.mention ? '3px' : '0px')};
  padding: ${props => (props.mention ? '2px 4px' : '0px')};
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;

export const Tag = styled.li`
  /* FIXME: Replace this component by Badge component */
  padding: 0.5em 1em 0.6em;
  border-radius: ${props => props.theme.borderRadius.large};
  font-size: ${props =>
    props.size
      ? props.theme.font.size[props.size]
      : props.theme.font.size.default};
  color: ${props => props.theme.color.wfBlack};
  display: inline-block;
  background-color: ${props => props.theme.color.wfGrey200};
  &:hover {
    background-color: ${props => props.theme.color.wfGrey300};
    cursor: pointer;
  }
`;

export const ImageContainer = styled.div`
  display: inline-block;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
`;

export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  & button:first-of-type {
    margin-left: 0;
    margin-right: 6px;
  }
  & button:last-of-type {
    margin-left: 6px;
    margin-right: 0;
  }
  & button {
    margin-left: 6px;
    margin-right: 6px;
  }
  & ${Link} {
    color: inherit;
  }
`;
